import { environment as base } from './environment';
import { client } from './environment.client';

export const environment = {
  ...base,
  production: true,
  apiUrl: 'https://api-policies.aclarian.com/api/',
  baseUrl: 'https://api-policies.aclarian.com/',
  datadogClientToken: client.datadogProd.clientToken,
  datadogApplicationId: client.datadogProd.applicationId,
  datadogService: `${client.datadogServicePrefix}_prod`,
  env: 'PROD',
};
